var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6.12214C10.5818 6.12214 9.43701 7.18662 9.43701 8.50531C9.43701 9.824 10.5818 10.8885 11.9999 10.8885C13.418 10.8885 14.5628 9.824 14.5628 8.50531C14.5628 7.18662 13.418 6.12214 11.9999 6.12214ZM7.72842 8.50531C7.72842 6.30916 9.63814 4.53336 11.9999 4.53336C14.3616 4.53336 16.2714 6.30916 16.2714 8.50531C16.2714 10.7014 14.3616 12.4773 11.9999 12.4773C9.63814 12.4773 7.72842 10.7014 7.72842 8.50531Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.931443 5.61735C3.67677 2.08946 7.66711 0 12 0C16.3331 0 20.3236 2.08966 23.0689 5.61788C23.7086 6.43767 24 7.49072 24 8.50002C24 9.50942 23.7085 10.5627 23.0686 11.3826C20.3232 14.9105 16.3329 17 12 17C7.6669 17 3.67637 14.9103 0.931033 11.3821C0.291383 10.5623 0 9.50921 0 8.50002C0 7.4905 0.291497 6.43725 0.931443 5.61735ZM12 1.58878C8.29132 1.58878 4.78683 3.37287 2.31528 6.5492L2.31447 6.55026C1.92953 7.04331 1.70859 7.74969 1.70859 8.50002C1.70859 9.25024 1.92953 9.95672 2.31447 10.4497L2.31528 10.4507C4.78683 13.6271 8.29132 15.4112 12 15.4112C15.7087 15.4112 19.2131 13.6271 21.6847 10.4507L21.6855 10.4497C22.0704 9.95672 22.2914 9.25024 22.2914 8.50002C22.2914 7.74969 22.0704 7.04331 21.6855 6.55026L21.6847 6.5492C19.2131 3.37287 15.7087 1.58878 12 1.58878Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.25e06b583ecbc46f4786c220684e21de.svg";
export { ForwardRef as ReactComponent };